/**
 * @file 获取列表数据
 * @author cuibolun(cuibolun@baijia.com)
 * @date 2021-03-04
 */

import http from './http';
import constant from './constant';

// eslint-disable-next-line import/prefer-default-export
export const fetchUserInfo = () => http.get(constant.USER.GET_USER_INFO, {});
